import { render, staticRenderFns } from "./Imagenes.vue?vue&type=template&id=42134992&scoped=true&"
import script from "./Imagenes.vue?vue&type=script&lang=js&"
export * from "./Imagenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42134992",
  null
  
)

export default component.exports